module.exports = __webpack_public_path__ + "img/icon2-5.3e44fa67.png";